import { yupResolver } from "@hookform/resolvers/yup";
import classnames from "classnames";
import Link from "next/link";
import { useForm } from "react-hook-form";
import * as y from "yup";
import { Button } from "@/components/Buttons/index";
import routes from "@/lib/routes";
import formStyles from "@/styles/Form.module.scss";
import loginStyles from "@/styles/Login.module.scss";
import processStyles from "@/styles/Process.module.scss";
import ErrorMessage from "./Parts/ErrorMessage";
import { PasswordField, TextField } from "./Parts/index";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const schema = y.object().shape({
  loginid: y.string().email("メールアドレスの形式で入力してください。").required("メールアドレスが入力されていません。"),
  password: y.string().required("パスワードが入力されていません。")
});

// ログイン画面3
export default function SpooxLoginForm(props) {
  var _errors$loginid, _errors$password;
  const {
    onSubmit,
    error,
    mappingError
  } = props;
  const {
    formState,
    register,
    handleSubmit,
    errors
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all"
  });
  const {
    isDirty,
    isValid,
    isSubmitting
  } = formState;
  return /*#__PURE__*/_jsx("form", {
    onSubmit: handleSubmit(onSubmit),
    noValidate: true,
    children: /*#__PURE__*/_jsx("div", {
      className: `${processStyles.content} ${loginStyles.loginSet}`,
      children: /*#__PURE__*/_jsxs("div", {
        className: `${loginStyles.loginSection} ${loginStyles.formSection}`,
        children: [/*#__PURE__*/_jsxs("h3", {
          className: loginStyles.sectionTitle,
          children: ["\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u306BSPOOX\u30A2\u30AB\u30A6\u30F3\u30C8\u3092\u9023\u643A", /*#__PURE__*/_jsx("div", {
            className: loginStyles.normalWeight,
            children: "\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u3078\u9023\u643A\u3057\u305F\u3044SPOOX ID\u30FB\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u3054\u5165\u529B\u304F\u3060\u3055\u3044\u3002"
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: loginStyles.sectionInner,
          children: [error && /*#__PURE__*/_jsx(ErrorMessage, {
            msg: error.message
          }), mappingError && /*#__PURE__*/_jsx(ErrorMessage, {
            msg: mappingError.message
          }), /*#__PURE__*/_jsx("fieldset", {
            children: /*#__PURE__*/_jsx(TextField, {
              ref: register,
              title: "SPOOX ID\uFF08E\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9\uFF09",
              type: "email",
              name: "loginid",
              placeholder: "SPOOX ID\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044",
              error: (_errors$loginid = errors.loginid) === null || _errors$loginid === void 0 ? void 0 : _errors$loginid.message
            })
          }), /*#__PURE__*/_jsxs("fieldset", {
            children: [/*#__PURE__*/_jsx(PasswordField, {
              ref: register,
              name: "password",
              title: "SPOOX\u306E\u30D1\u30B9\u30EF\u30FC\u30C9",
              placeholder: "\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B",
              error: (_errors$password = errors.password) === null || _errors$password === void 0 ? void 0 : _errors$password.message
            }), /*#__PURE__*/_jsxs("p", {
              className: loginStyles.caption,
              children: ["\u203B\u73FE\u5728\u3054\u5951\u7D04\u4E2D\u306E\u5546\u54C1\u53CA\u3073\u767B\u9332\u6E08\u307F\u652F\u6255\u65B9\u6CD5\u306E\u7D99\u7D9A\u5229\u7528\u306B\u306F\u3001SPOOX ID\u3068\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u306E\u9023\u643A\u304C\u5FC5\u8981\u3067\u3059\u3002", /*#__PURE__*/_jsx("br", {}), "\u203B\u9023\u643A\u5F8C\u306FSPOOX ID\u306F\u3054\u4F7F\u7528\u3067\u304D\u307E\u305B\u3093\u306E\u3067\u3001\u9023\u643A\u3057\u305F\u30B9\u30AB\u30D1\u30FC\uFF01\u30E1\u30F3\u30D0\u30FC\u30BAID\u3067\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002"]
            }), /*#__PURE__*/_jsxs("p", {
              className: classnames(formStyles.formInputInfo, processStyles.center),
              children: ["\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u304A\u5FD8\u308C\u306E\u65B9\u306F", /*#__PURE__*/_jsx(Link, {
                href: routes.passwordRemind,
                className: "mainColor",
                children: "\u3053\u3061\u3089\u304B\u3089"
              }), "\u30EA\u30BB\u30C3\u30C8\u3067\u304D\u307E\u3059\u3002"]
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: loginStyles.loginBtnArea,
            children: /*#__PURE__*/_jsx(Button, {
              type: "submit",
              fillMainColor: true,
              large: true,
              fontFixed: true,
              fontBold: true,
              disabled: !isDirty || !isValid,
              loading: isSubmitting,
              children: "ID\u9023\u643A"
            })
          })]
        })]
      })
    })
  });
}